let token = '';
const initialState = token;
const userTokenReducer = (state = initialState, action = {}) => {
    if (action.type === 'USER_LOGGED_IN') {
        token = action.payload;
        return token;
    }
    return state;
}

export default userTokenReducer;
